 <!-- freetext -->

    <div *ngIf="(freeTexts && freeTexts.length > 0) || questionComments" class="padding-top-lg break-inside-avoid" [ngClass]="{'side-margins': !noMargin}">
            
        <div class="title text-center">{{ !questionMode ? ('FREETEXT_PANEL.FREE_TEXT_FEEDBACK' | translate): ('FREETEXT_PANEL.FREE_TEXT_EVALUATIONS_COMMENTS' | translate)}}</div>
        <div class="sub-title text-center" *ngIf="showSubTitle">{{ subTitle }}</div>
        
        <div class="content">
            <div *ngFor="let item of freeTexts" class="text-line text-justify">
                <p>{{ item }}</p>
            </div>

            <ng-container *ngIf="questionMode && questionComments">
                <div class="comments">
                    <div *ngFor="let item of questionComments" class="question-block">
                        <div class="question-name">
                            <strong>{{ item.questionIndex + 1 }}. {{ item.questionName }}</strong>
                        </div>
                        <ul class="list-comments">
                            <li *ngFor="let comment of item.comments" class="text-line text-justify">
                                <p>{{ comment }}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
